export const useUsersStore = defineStore('users', {
  state: () => {
    return {
      roles: [
        'admin',
        'creator',
        'editor',
      ],
      users: [],
      usersCount: 0,
      currentOnboardingStep: null,
    };
  },

  actions: {
    // User
    async fetchUsers(params) {
      this.users = [];

      const response = await useApi.get('/users', {
        params,
      }).catch(() => {
        useToast.error(useT('common.errorLoadingData'));
      });

      if (response) {
        this.users = response.results;
      }

      return response;
    },

    async fetchUsersCount() {
      const response = await useApi.get('/users/count').catch(() => {
        useToast.error(useT('common.errorLoadingData'));
      });

      if (response) {
        this.usersCount = response;
      }

      return response;
    },

    async changeUserRole({ role, user }) {
      const response = await useApi.put(`/users/${user._id}`, {
        body: {
          role,
        },
      }).catch(() => {
        useToast.error(useT('user.role.error'));
      });

      if (response?.role) {
        _find(this.users, { id: user._id }).role = role;

        useToast(useT('user.role.changed'));
      }

      return response;
    },

    async deleteUser(user) {
      const response = await useApi.delete(`/users/${user._id}`).catch(() => {
        useToast.error(useT('user.role.errorDelete'));
      });

      if (response) {
        _remove(this.users, { id: user._id });

        useToast(useT('user.deleted'));

        useUsersStore().fetchUsersCount();
      }

      return response;
    },

    // User/Me
    async updateUserMe(body) {
      const response = await useApi.put('/users/me', { body }).catch(() => {
        useToast.error(useT('user.edited.error'));
      });

      return response;
    },

    async updateUserMePassword(body) {
      const response = await useApi.put('/users/me/password', { body }).catch((error) => {
        if (error.response.status === 403) {
          useToast.error(useT('user.password.notSame'));
        } else {
          useToast.error(useT('common.errorSavingChanges'));
        }
      });

      return response;
    },

    async completeOnboardingStep({ onboardingName, stepIds }) {
      // Optimistically update: add steps if not already completed
      const previousSteps = useAuthStore().user.onboarding?.[onboardingName]?.completedSteps || [];
      const newSteps = stepIds.filter((stepId) => !previousSteps.includes(stepId));

      if (newSteps.length > 0) {
        const updatedSteps = [...previousSteps, ...newSteps];
        _set(useAuthStore().user, `onboarding.${onboardingName}.completedSteps`, updatedSteps);

        if (isOnboardingComplete(onboardingName, updatedSteps)) {
          _set(useAuthStore().user, `onboarding.${onboardingName}.isFinished`, true);

          useConfetti();
        }
      }

      const response = await useApi.post('/users/me/onboarding/complete-step', {
        body: { onboardingName, stepIds },
      }).catch(async(error) => {
        console.error('Error completing onboarding step:', error);
        useToast.error(useT('common.errorSavingChanges'));
        await useAuthStore().fetchUser();
        return null;
      });


      return response;
    },

    // User/Invites
    async sendUserInvite(body) {
      const response = await useApi.post('/users/invite', {
        body,
      }).catch((error) => {
        if (error?.statusCode === 400 && error?.response?._data) {
          useToast.error(error.response._data);
        } else {
          useToast.error(useT('user.invite.error'));
        }
      });

      if (response) {
        useUsersStore().fetchUsersCount();
      }

      return response;
    },

    async sendUserInvites(body) {
      const response = await useApi.post('/users/invites', {
        body,
      }).catch((error) => {
        if (error?.statusCode === 400 && error?.response?._data) {
          useToast.error(error.response._data);
        } else {
          useToast.error(useT('user.invite.error'));
        }
      });

      if (response) {
        useUsersStore().fetchUsersCount();
      }

      return response;
    },
  },
});
